import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-notification/es/index.js
// module id = 281
// module chunks = 0 1